/* eslint-disable ssr-friendly/no-dom-globals-in-module-scope */
import * as React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client'
import EventRegistrationRefreshApp from './components/event-reg-refresh-app';
import { IEpiProps } from './models/event-reg-refresh-models';

const entryDiv = document.getElementById('event-reg-root');

if (entryDiv) {
  const root = createRoot(entryDiv)
  const { epiProperties, eventRegistrationRefreshModel } = (window as any).bootstrap

  root.render(<EventRegistrationRefreshApp
    epiProps={epiProperties}
    eventRegistrationRefreshModel={eventRegistrationRefreshModel}
  />)
}
